import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, HostListener, Output, OnDestroy, Renderer2, AfterViewInit } from '@angular/core';

import 'hammerjs';

import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { LeftSportsMenuDialog } from '@app/dialogs/left-sport-menu.dialog';
import { UserHelper } from '@helpers/user.helper';
import { LoadingDialog } from '@app/dialogs/loading.dialog';
import { LanguageChangerDialog } from '@app/dialogs/language.changer.dialog';

import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';

import { timer, Observable, Subject, interval, fromEvent } from 'rxjs';
import { takeUntil, tap, filter, delay, throttle, throttleTime, debounceTime } from 'rxjs/operators';
import { IdleDialog } from '../../../dialogs/idle.dialog';

import { EnableCookieConsent, AvailableCountries, environment } from '../../../../environments/environment';

import { TranslatePipe } from '../../../pipes/translate.pipe';
import { StandingsDialogComponent } from '../../standings.dialog.component';
import { LoadingTicketDialog } from 'src/app/dialogs/loading-ticket.dialog';
import { DepositLimitDialog } from '../../deposit-limit.dialog';
import { de } from 'date-fns/locale';
import { WalletControl } from '@pipes/walletControl.pipe';
import { ConsentScreenDialog } from '@app/components/consent-screen-dialog.component';
import { LugasLimitDialog } from '@app/components/lugas-limit.dialog';
import { ResetLimitDialog } from '@app/components/reset-limit.dialog';

@Component({
  selector: 'app-root',
  templateUrl: '../../../sharedTemplates/core.component.html',
})
export class CoreComponent implements OnInit, AfterViewInit {
  constructor(
    public _UiHelper: UiHelper,
    private _Localization: LocalizationService,
    private _ApiService: ApiService,
    public _MatDialog: MatDialog,
    private _ElementRef: ElementRef,
    private _Renderer2: Renderer2,
    public _UserHelper: UserHelper,
    private _DataHelper: DataHelper,
    private route: ActivatedRoute,
    private _Router: Router,
    private _SignalrServiceLegacy: SignalrServiceLegacy,
    private _LocalizationService: LocalizationService,
    public dialog: MatDialog
  ) {
    this.setThemeStateInit();

    this.cancel = this.state.pipe(
      filter(v => v === 'cancel'),
      tap(v => {
        this.holdTime.emit(0);
        this.holdSeconds = 0;
        this.progressValue = 0;
      })
    );

    this.getAntiForgeryToken();
    this.appTimer();

    this.responsiveResolution(this._UiHelper.windowsWidth);

    this._UiHelper.windowResized.subscribe(x => {
      this.resizeChangeListener.next(x.w);
    });

    this.resizeChangeListener.pipe(debounceTime(1000)).subscribe(width => {
      this.responsiveResolution(width);
    });

    setInterval(() => {
      if (this._UserHelper.isSignedIn != undefined && this._UserHelper.isSignedIn && this._UserHelper.customerUser.CustomerId) {
        this._ApiService.getClient2().then().catch();
      }
    }, 60000);

    this._UiHelper.responsiveResolutionListener.subscribe(x => {
      console.log(x);
    });
    // cashout Initial data check when user signIn
    this._UserHelper.signInListener.subscribe(x => {
      if (x) {
        this._ApiService.getCashoutSlipsExternal(1);
        this._UiHelper.consentScreenDialogListener.emit(true);
        this.idleTimerCheck();
      }

      if (!this._UserHelper.isSignedIn) {
        if (environment.product === 'b500' || environment.product === 'cangobet') {
          this._UiHelper.loginDropDownIsOpen = true;
        }
      }
    });

    this.getSliderDesktop();
  }

  setThemeStateInit() {
    if (localStorage.getItem('themeState')) {
      const bodyElement = document.getElementsByTagName('body');
      this._UiHelper.currentTheme = localStorage.getItem('themeState');
      if (bodyElement && bodyElement.length > 0) {
        bodyElement[0].classList.add(localStorage.getItem('themeState'));
      }
    } else {
      const bodyElement = document.getElementsByTagName('body');
      localStorage.setItem('themeState', 'theme-light');
      this._UiHelper.currentTheme = 'theme-light';
      if (bodyElement && bodyElement.length > 0) {
        bodyElement[0].classList.add('theme-light');
      }
    }
  }
  // bet3000
  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;
  quickTippIsActive = true;
  isMobileView = false;

  // bet3000
  leftMenu = false;
  rightMenu = false;
  loadingDialogBlur = false;
  navbar_titleTranslate = '';
  navbar_title = '';
  navbar_showed = false;
  isRegister = false;
  isLive = false;
  isHelpPage = false;
  isAccount = false;

  isStatisticsIframe = false;
  isLiveScoreIframe = false;
  isEuro2020Iframe = false;

  _contentMarginTop = 0;

  constentShow;
  history = [];

  holdSeconds = 0;
  progressValue = 0;
  accountLockIsDisabled = false;
  private loadingDialogRef: MatDialogRef<LoadingDialog>;

  // LOCK BUTTON
  @Output() holdTime: EventEmitter<number> = new EventEmitter<number>();
  state: Subject<string> = new Subject<string>();
  cancel: Observable<string>;

  lastPing?: Date = null;

  _flagCashoutInitial = false;

  resizeChangeListener = new Subject();

  lugasLimitDialogRef: any;
  resetLimitDialogRef: any;

  idleDialogRef: any;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    this._UiHelper.setDocumentScrollPX(document.documentElement.scrollTop);
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  @HostListener('window:resize', ['$event'])
  onResizeBrowser(event) {
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('mouseleave', ['$event'])
  onExit() {
    this.state.next('cancel');
  }

  @HostListener('mousedown', ['$event'])
  onHold(e) {
    const target = e.target || e.srcElement || e.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr == undefined) {
      return '';
    }

    const value = idAttr.nodeValue;
    if (value != 'accountLockButton24') {
      return '';
    }

    this.state.next('start');

    const n = 100;
    interval(n)
      .pipe(
        takeUntil(this.cancel),
        tap(v => {
          const result = v * n;
          this.holdSeconds = result / 1000;
          this.progressValue = (this.holdSeconds / 3) * 100;
          if (result == 3000) {
            this.state.next('cancel');

            const translator = new TranslatePipe(this._LocalizationService);
            this._ApiService.accountLock24().then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = translator.transform(result.message, null);
                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  this._UiHelper.successSnackBar(result.message, '');
                  this.holdSeconds = 0;
                  this.progressValue = 0;
                  this.accountLockIsDisabled = true;
                }
              }
            });
          }

          this.holdTime.emit(result);
        })
      )
      .subscribe();
  }
  openLugasLimitDialog(): void {
    if (this._UserHelper.IsLimitSet === false && this._UserHelper.emailIsVerified) {
      if (this.lugasLimitDialogRef && this.lugasLimitDialogRef.getState() === MatDialogState.OPEN) {
        return;
      }
      if (environment.lugasCheck) {
        this.lugasLimitDialogRef = this.dialog.open(LugasLimitDialog, {
          width: '90%',
          height: '600px',
          panelClass: 'lugas-dialog-class',
          disableClose: true,
        });
      }
    }
  }
  openResetLimitDialog(): void {
    if (!this._DataHelper.selectedWallet.IsResetActive && this._DataHelper.selectedWallet.BranchType === 1) {
      if (this.resetLimitDialogRef && this.resetLimitDialogRef.getState() === MatDialogState.OPEN) {
        return;
      }
      if (environment.lugasCheck) {
        this.resetLimitDialogRef = this.dialog.open(ResetLimitDialog, {
          width: '100%',
          height: 'calc(100vh - 120px)',
          panelClass: 'reset-limit-dialog-class',
          disableClose: true,
        });
      }
    }
  }
  getAntiForgeryToken() {
    const element = this._Renderer2.selectRootElement('#cont_antiforgerytoken input');
    this._ApiService.setAntiForgeryToken(element.value);
  }

  leftMenuChanged(e) {
    if (!e) {
      this._UiHelper.leftMenu = e;
      this.leftMenu = e;
    }
  }

  rightMenuChanged(e) {
    if (!e) {
      this._UiHelper.rightMenu = e;
      this.rightMenu = e;
    }
  }

  leftSportMenuDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      dialogRef
        .open(LeftSportsMenuDialog, {
          width: '350px',
          minHeight: '35vh',
          panelClass: 'left-sports-menu-dialog',
        })
        .afterClosed()
        .subscribe();
    } else {
      dialogRef.closeAll();
    }
    // dialogRef.componentInstance.data = purpose;
  }

  loadingDialogOpener(x) {
    if (x) {
      if (!this._MatDialog.getDialogById('loadingD')) {
        this.loadingDialogRef = this._MatDialog.open(LoadingDialog, {
          id: 'loadingD',
          width: '350px',
          minHeight: '35vh',
          panelClass: 'loadingDialog',
          disableClose: true,
          closeOnNavigation: true,
        });

        this.loadingDialogRef.afterClosed().subscribe(result => {
          this._UiHelper.setLoadingDialog(false);
        });
        this.loadingDialogBlur = true;
      } else {
        this.loadingDialogBlur = false;
        // closeall maybe cause side effect
      }
    }
  }

  loadingTicketDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      dialogRef
        .open(LoadingTicketDialog, {
          width: '250px',
          minHeight: '100px',
          panelClass: 'loadingTicketDialog',
          disableClose: true,
          closeOnNavigation: true,
        })
        .afterClosed()
        .subscribe(result => {
          this._UiHelper.setLoadingDialog(false);
        });
      this.loadingDialogBlur = true;
    } else {
      this.loadingDialogBlur = false;
      // closeall maybe cause side effect
    }
  }

  languageChangeDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      dialogRef
        .open(LanguageChangerDialog, {
          width: '300px',
        })
        .afterClosed()
        .subscribe();
    } else {
      dialogRef.closeAll();
    }
    // dialogRef.componentInstance.data = purpose;
  }

  setContentMarginTop(x) {
    this._contentMarginTop = x;
  }

  refreshAPP() {
    window.location.href = '/home';
  }

  ngOnInit() {
    if (EnableCookieConsent) {
      if (localStorage.getItem('_C')) {
        this.constentShow = localStorage.getItem('_C');
      } else {
        this.constentShow = '1';
      }
    }

    document.addEventListener('visibilitychange', e => {
      if (document.visibilityState === 'visible') {
        this._UiHelper.setIsTabActive(true, e.timeStamp);
      } else if (document.visibilityState === 'hidden') {
        this._UiHelper.setIsTabActive(false, e.timeStamp);
      }
    });

    this._UiHelper.isTabActiveListener.subscribe((x: any) => {
      return;
    });
    this._ApiService.getSideBanner().then();
  }
  private readonly INACTIVE_TIME = environment.idleObject.idleTime; // 30 dakika

  private lastInteractionTime: number;

  intervalId;
  idleTimerCheck() {
    if (environment.idleObject.isOpenIdleModal) {
      this.lastInteractionTime = Date.now();
      this.intervalId = setInterval(() => {
        if (Date.now() - this.lastInteractionTime >= this.INACTIVE_TIME) {
          // console.log('30 dakika boyunca herhangi bir etkileşim olmadı!');
          if (this._UserHelper.isSignedIn) {
            if (this.idleDialogRef && this.idleDialogRef.getState() === MatDialogState.OPEN) {
              return;
            }
            this.idleDialogRef = this.dialog.open(IdleDialog, {
              width: '350px',
              height: '250px',
              disableClose: true,
            });

            clearInterval(this.intervalId);
          }
        }
      }, 1000);
    }
  }

  @HostListener('window:mousemove')
  @HostListener('window:click')
  onInteraction() {
    this.lastInteractionTime = Date.now();
  }

  constentForm() {
    localStorage.setItem('_C', '0');
    this.constentShow = '0';
  }

  ngAfterViewInit() {
    this._ApiService
      .getSlider('2')
      .then(x => {
        let slider_Data;
        slider_Data = x.filter(element => {
          return new Date() <= new Date(Number(element.EndDate.replace(/\D/g, ''))) && new Date() >= new Date(Number(element.StartDate.replace(/\D/g, '')));
        });
        this._DataHelper.setHomeSliderData(slider_Data);
      })
      .catch(err => console.log('core', err));
    this._DataHelper.numberOfBetsListener.subscribe(x => {
      if (x === 0 || x === 1) {
        this.quickTippIsActive = true;
      } else if (x >= 2) {
        this.quickTippIsActive = false;
      }
    });

    // this.startInterval();
    this._UiHelper.leftMenuListener.subscribe(x => (this.leftMenu = x));
    this._UiHelper.rightMenuListener.subscribe(x => (this.rightMenu = x));
    this._UserHelper.LugasDialogListener.subscribe(x => {
      if (x) {
        this.openLugasLimitDialog();
      }
    });
    this._UserHelper.ResetDialogListener.subscribe(x => {
      if (x) {
        this.openResetLimitDialog();
      }
    });
    this._UiHelper.leftSportsMenuDialogListener.subscribe(x => this.leftSportMenuDialogOpener(x));
    this._UiHelper.loadingDialogListener.subscribe(x => this.loadingDialogOpener(x));
    this._UiHelper.loadingTicketDialogListener.subscribe(x => this.loadingTicketDialogOpener(x));

    this._UiHelper.languageChangerDialogListener.subscribe(x => this.languageChangeDialogOpener(x));
    this._UiHelper.consentScreenDialogListener.subscribe(x => this.openConsentScreenDialog());
    this._UiHelper.setResolution(window.innerWidth, window.innerHeight);
    this._UiHelper.contentMarginTopListener.subscribe(x => {
      this.setContentMarginTop(x);
    });
    this._UiHelper.navbarTitleListener.subscribe(x => {
      if (x.isRaw) {
        this.navbar_title = x.s;
        this.navbar_titleTranslate = '';
      } else {
        this.navbar_title = '';
        this.navbar_titleTranslate = x.s;
      }
      this.navbar_showed = x.show;
    });
    this._UiHelper.refreshAppListener.subscribe(x => {
      this.refreshAPP();
    });

    this._UiHelper.currentRoute === '/live' ? (this.isLive = true) : (this.isLive = false);
    this._UiHelper.currentRoute === '/help' ? (this.isHelpPage = true) : (this.isHelpPage = false);
    this._UiHelper.currentRoute === '/virtualgamegr' ? (this.isLive = true) : null;
    this._UiHelper.currentRoute === '/virtualgamegr' ? (this.isAccount = true) : null;
    this._UiHelper.currentRoute === '/register' ? (this.isRegister = true) : (this.isRegister = false);

    if (this._UiHelper.currentRoute.indexOf('statistics') > -1) {
      this.isStatisticsIframe = true;
    } else {
      this.isStatisticsIframe = false;
    }

    if (this._UiHelper.currentRoute.indexOf('livescore') > -1) {
      this.isLiveScoreIframe = true;
    } else {
      this.isLiveScoreIframe = false;
    }

    if (this._UiHelper.currentRoute.indexOf('euro2020') > -1) {
      this.isEuro2020Iframe = true;
    } else {
      this.isEuro2020Iframe = false;
    }

    this._UiHelper.currentRouteListener.subscribe(x => {
      x == '/live' ? (this.isLive = true) : (this.isLive = false);
      x == '/virtualgamegr' ? (this.isLive = true) : null;
      x == '/register' ? (this.isRegister = true) : (this.isRegister = false);

      if (x.indexOf('statistics') > -1) {
        this.isStatisticsIframe = true;
      } else {
        this.isStatisticsIframe = false;
      }

      if (x.indexOf('livescore') > -1) {
        this.isLiveScoreIframe = true;
      } else {
        this.isLiveScoreIframe = false;
      }

      if (x.indexOf('euro2020') > -1) {
        this.isEuro2020Iframe = true;
      } else {
        this.isEuro2020Iframe = false;
      }
    });

    // IsAccount Setting
    this._UiHelper.currentRoute === '/slips' ||
    this._UiHelper.currentRoute === '/bookings' ||
    this._UiHelper.currentRoute === '/deposit' ||
    this._UiHelper.currentRoute === '/withdraw' ||
    this._UiHelper.currentRoute === '/document' ||
    this._UiHelper.currentRoute === '/accountdownload' ||
    this._UiHelper.currentRoute === '/accountlock' ||
    this._UiHelper.currentRoute === '/selflimits' ||
    this._UiHelper.currentRoute === '/inbox' ||
    this._UiHelper.currentRoute === '/changepassword' ||
    this._UiHelper.currentRoute === '/userprofile' ||
    this._UiHelper.currentRoute === '/slipdetail' ||
    this._UiHelper.currentRoute === '/bonus'
      ? (this.isAccount = true)
      : (this.isAccount = false);
    this._UiHelper.currentRouteListener.subscribe(x => {
      x === '/slips' ||
      x === '/bookings' ||
      x === '/deposit' ||
      x === '/withdraw' ||
      x === '/document' ||
      x === '/accountdownload' ||
      x === '/accountlock' ||
      x === '/selflimits' ||
      x === '/inbox' ||
      x === '/changepassword' ||
      x === '/userprofile' ||
      x.includes('/slipdetail') ||
      x.includes('/withdraw') ||
      x.includes('/deposit') ||
      x.includes('/bonus')
        ? (this.isAccount = true)
        : (this.isAccount = false);

      x == '/virtualgamegr' ? (this.isAccount = true) : null;
    });
    // IsAccount Setting

    this._UiHelper.setNavbarTitle('', false, false);

    // if (this._UserHelper.isSignedIn) {
    // If Already signed in
    this._ApiService
      .getClient()
      .then(result => {
        this._UserHelper.setUser(result);

        if (this._UserHelper.isSignedIn) {
          if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined) {
            this._ApiService.getWalletList().then(result => {
              // this._UserHelper.walletList=result;
              this._UserHelper.setWalletList(result);
            });
          }
        }
      })
      .catch();
    // }

    // Sports Filter Control
    this._DataHelper.LeagueDataListener.subscribe(x => {
      // this._Router.navigate(['/sports'], { queryParams: { countryIDs: a, TourementIDs: b } });
      this._Router.navigate(['/sports']);
    });
    this._ApiService.getCurrentSlip();

    this.getTaxRate();

    this._ApiService
      .getCountryInfo()
      .then(result => {
        if (result && result !== 'DE' && result !== 'ok' && environment.product === 'wettarena') {
          window.location.href = 'https://wettarena.de/country-filter.html';
        }
      })
      .catch();

    this._UiHelper.loadingDialogListener.subscribe(x => {
      if (!x && this._MatDialog.getDialogById('loadingD')) {
        // this.loadingDialogRef.close();
        this._MatDialog.getDialogById('loadingD').close();
      }
    });
    /*
//todo kaldırıldı. Bakılacak
    this._UserHelper.walletListLoadingListener.subscribe(isWalletLoaded => {
      if (isWalletLoaded && (this._DataHelper.selectedWallet.BranchType == 1 || this._DataHelper.selectedWallet.BranchType == 2)) {
        if (this._DataHelper.depositLimitDialogState) {
          this.openDepositLimitDialog();
        }
      } else {
        this._DataHelper.depositLimitDialogState = true;
      }
    });

 */
  }

  getTaxRate() {
    this._ApiService.getTaxRate().then(result => {
      this._DataHelper.setTaxRate(result);
    });
  }

  appTimer() {
    const source = timer(20000, 60000);
    const abc = source.subscribe(val => {
      // Token Updater
      this.getAntiForgeryToken();
      // Balance Updater
      if (this._UserHelper.isSignedIn && this._UserHelper.customerUser.CustomerId) {
        this._ApiService
          .getClient2()
          .then(result => {
            if (!this._flagCashoutInitial) {
              if (this._UserHelper.isSignedIn) {
                if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined) {
                  // this._ApiService.getWalletList().then((result) => {
                  //   this._UserHelper.setWalletList(result);
                  // });

                  this._flagCashoutInitial = true;
                }
              }
            }
          })
          .catch();
      }
    });
  }

  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }

  toggleSportsMenu() {
    this.isOpenSportsMenu = !this.isOpenSportsMenu;
  }

  openStats(e) {
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialog',
      panelClass: 'standingsDialogClass',
      height: '90%',
      data: {
        tournamentId: '',
        sportId: '',
        betradarMatchId: '',
        type: e,
      },
    });
  }

  closeQuickTippOutput(e) {
    this.quickTippIsActive = false;
  }
  /*

    openDepositLimitDialog(): void {
      const walletControl = new WalletControl(this._UserHelper);
      this._ApiService.getSelfLimits().then(x => {
        if (
          x &&
          x.length > 0 &&
          x[0].DepositMonthlyLimitConsumed === null &&
          ((this._DataHelper.selectedWallet.BranchType == 1 && walletControl.transform(true, 'IsVerification')) || this._DataHelper.selectedWallet.BranchType == 2)
        ) {
          const dialogRef = this.dialog.open(DepositLimitDialog, {
            width: '550px',
            panelClass: 'transcationDialog',
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe();
          this._DataHelper.depositLimitDialogState = false;
        }
      });
    }

   */

  responsiveResolution(width) {
    if (width <= 990) {
      this._UiHelper.setResponsiveResolution('xs');
    } else if (width > 990 && width <= 1150) {
      this._UiHelper.setResponsiveResolution('s');
      // this._UiHelper.setResponsiveResolution('m');
    } else if (width > 1150 && width <= 1370) {
      this._UiHelper.setResponsiveResolution('l');
    } else if (width > 1370 && width <= 1640) {
      this._UiHelper.setResponsiveResolution('xl');
    } else {
      this._UiHelper.setResponsiveResolution('xxl');
    }

    if (width <= 990) {
      this.isMobileView = true;
    } else if (width > 990) {
      this.isMobileView = false;
    }
  }
  consentScreenRef: any;
  openConsentScreenDialog(): void {
    if (this.consentScreenRef && this.consentScreenRef.getState() === MatDialogState.OPEN) {
      return;
    }
    if (!this._UserHelper?.customerUser.IsContractAccepted) {
      this.consentScreenRef = this.dialog.open(ConsentScreenDialog, {
        width: '610px',
        panelClass: 'transcationDialog-center',
        disableClose: true,
        height: '400px',
      });
    }
  }

  getSliderDesktop() {
    this._ApiService
      .getSliderWeb('2')
      .then(x => {
        if (x && x.length > 0) {
          this._UiHelper.sliderWebData = x;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
